import React from 'react';
import Helmet from 'react-helmet';

import Masthead from '../components/Masthead';
import Constrain from '../components/Constrain';
import ContactForm from '../components/ContactForm';

import whatWeDoImg from '../images/idea-in-hand.jpg';
import aboutArtiseqImg from '../images/shoreditch-artwork.jpg';

import styles from './index.module.css';
const IndexPage = () => (
    <div>
        <Helmet
            title="Artiseq - Consultants"
            meta={[
  /*               { name: 'description', content: 'Re-inventing the traditional procurement process by matching buyers and suppliers in the private tender market.' },
                 { name: 'keywords', content: 'procurement, private sector tenders, private tenders, small business procuremet, leads, opportunities, global opportunities, trade, export help, export, begin exporting' },
   */         ]}
        />
{/*
        <Masthead />
        <Constrain>

            <div className={styles.whatWeDo}>

                <h2>What we do</h2>

                <p>
                    We are re-inventing the traditional procurement process by revolutionising
                    the way businesses find global opportunities.
                    Let us help you unlock your exporting potential!
                </p>

                <div className={styles.whatWeDoImg}>
                    <img src={whatWeDoImg} alt='What we do at Artiseq' />
                </div>

                <p>
                    At Artiseq, we provide two key services. Firstly, we'll help you find global export
                    opportunities, using our bespoke algorithm will match you with global opportunities.
                    Next, we will get you export ready; our pool of market and industry experts
                    can help you unlock your exporting potential.
                </p>

            </div>

            <div className={styles.aboutArtiseq}>

                <h2>About Artiseq</h2>

                <div className={styles.aboutArtiseqImg}>
                    <img src={aboutArtiseqImg} alt='Where we are' />
                </div>

                <p>
                    Artiseq was founded with one goal in mind, to disrupt the traditional procurement process.
                    We are designed specifically for small to medium sized (SME) enterprises,
                    but of course, we also cater for larger organisations too.
                </p>

                <p>
                    Here at Artiseq, we want to revolutionise the way buyers and suppliers are identified and matched.
                </p>

            </div>

            <div className={styles.getInTouch}>

                <div className={styles.getInTouchContent}>

                    <h2>Get in touch</h2>

                    <p>
                        If you're interested in our help or would like to find out more, please get in contact!
                    </p>

                </div>

                <div className={styles.contactForm}>

                    <ContactForm />

                </div>

            </div>

        </Constrain> */}

    </div>
);

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js